/**
 * Checks if a given string is an absolute URL (starts with a scheme like "http:", "https:", etc.)
 * Examples: "https://site.com", "ftp://server.com"
 */
export const isAbsoluteURL = (url: string) => {
  return /^([a-zA-Z][a-zA-Z\d+\-.]*:|\/\/)/.test(url);
};

/**
 * True when the value is a valid `https:` URL. A thin safety floor for content URLs (images, etc.) — rejects
 * `http:` mixed-content and `javascript:`/`data:` schemes without restricting which host serves the asset.
 */
export const isHttpsUrl = (value: unknown): value is string => {
  if (typeof value !== 'string') {
    return false;
  }
  try {
    return new URL(value).protocol === 'https:';
  } catch {
    return false;
  }
};

/**
 * Validates that the given URL belongs to one of the allowed domains.
 * Allows exact match (e.g., "cet.ac.il") and subdomains (e.g., "learning.cet.ac.il").
 */
export const verifyHostName = (urlStr: string, allowedDomains: string[]) => {
  if (!urlStr) {
    return false;
  }

  try {
    const url = new URL(urlStr);
    return allowedDomains.some(domain => url.hostname === domain || url.hostname.endsWith(`.${domain}`));
  } catch {
    return false;
  }
};
